var map = {
	"./admins.ts": "./js/admins.ts",
	"./calamiteitenplannen.ts": "./js/calamiteitenplannen.ts",
	"./darkmode.ts": "./js/darkmode.ts",
	"./edit_form.ts": "./js/edit_form.ts",
	"./editor.ts": "./js/editor.ts",
	"./faq.ts": "./js/faq.ts",
	"./form_stats.ts": "./js/form_stats.ts",
	"./functions.ts": "./js/functions.ts",
	"./lang_switcher.ts": "./js/lang_switcher.ts",
	"./lightbox.ts": "./js/lightbox.ts",
	"./login.ts": "./js/login.ts",
	"./menu.ts": "./js/menu.ts",
	"./menu_toggle.ts": "./js/menu_toggle.ts",
	"./pages.ts": "./js/pages.ts",
	"./settings.ts": "./js/settings.ts",
	"./slugs.ts": "./js/slugs.ts",
	"./sort.ts": "./js/sort.ts",
	"./submit.ts": "./js/submit.ts",
	"./table_actions.ts": "./js/table_actions.ts",
	"./versioncontrol.ts": "./js/versioncontrol.ts"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./js sync recursive \\.ts$";